"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.performInputStyle = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
exports.performInputStyle = {
    fontSize: 16,
    lineHeight: '20px',
    color: lib_palette_1.default.secondary.main,
};
